import { render, staticRenderFns } from "./activitiesManage.vue?vue&type=template&id=407d746f"
import script from "./activitiesManage.vue?vue&type=script&lang=js"
export * from "./activitiesManage.vue?vue&type=script&lang=js"
import style0 from "./activitiesManage.vue?vue&type=style&index=0&id=407d746f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports